import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../hooks/redux';
import {
  setGeneralSettingsChanged,
  setPendingNavigation,
  setPersonalInfoChanged,
  setShowWarningModal,
} from '../../store/slices/accountSlice';
import { TabItem, Tabs } from '../ui/Tabs/Tabs';
import Account from './Account/Account';
import GeneralSettings from './GeneralSettings/GeneralSettings';

export function SettingsTab() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    personalInfoChanged,
    generalSettingsChanged,
    showWarningModal,
    pendingNavigation,
  } = useAppSelector((state) => state.account);

  const tabs: TabItem[] = [
    {
      key: 'account',
      label: 'Account',
      content: <Account />,
      hasUnsavedChanges: personalInfoChanged,
    },
    {
      key: 'general',
      label: 'General Settings',
      content: <GeneralSettings />,
      hasUnsavedChanges: generalSettingsChanged,
    },
  ];

  const handleNavigationWarning = (targetPath: string) => {
    dispatch(setPendingNavigation(targetPath));
    dispatch(setShowWarningModal(true));
  };

  const handleConfirmNavigation = () => {
    if (pendingNavigation) {
      navigate(pendingNavigation);
      dispatch(setPendingNavigation(null));
      dispatch(setPersonalInfoChanged(false));
      dispatch(setGeneralSettingsChanged(false));
      dispatch(setShowWarningModal(false));
    }
  };

  const handleResetChanges = () => {
    dispatch(setPersonalInfoChanged(false));
    dispatch(setGeneralSettingsChanged(false));
  };

  return (
    <Tabs
      tabs={tabs}
      basePath="/settings"
      showWarningModal={showWarningModal}
      pendingNavigation={pendingNavigation}
      onNavigationWarning={handleNavigationWarning}
      onConfirmNavigation={handleConfirmNavigation}
      onResetChanges={handleResetChanges}
    />
  );
}
